import product from './product'

export default product
